/**
 * Regras da retirada do chip físico na loja da marca.
 *
 * A retirada é exclusiva das marcas com `habilitar_retirada_na_mvno` em
 * GET /logistica (coluna logistica_retirada_na_mvno_FRANQUIA_MARCA_PROPRIA).
 * Enquanto a logística não carrega, ou se a API não mandar o campo, a flag
 * fica `undefined` e é tratada como desligada: o lado seguro é cobrar o
 * frete e não oferecer a retirada.
 *
 * Fica aqui, e não nos componentes, porque a decisão é da marca e o link de
 * venda direta não pode ter lógica de MVNO dentro de componente React (ver
 * CLAUDE.md).
 */
export interface ChipOnlyPickUpVisibilityInput {
  physicalChipAvailable: boolean
  pickUpInStore?: boolean
}

/**
 * Visibilidade do bloco "Recebimento do chip físico" no step 1 da venda
 * somente chip. O bloco só existe para escolher entre receber em casa e
 * retirar na loja; sem a retirada, receber em casa é a única opção e o bloco
 * some, como no fluxo com plano (SelectChipInfo).
 *
 * O estoque de eSIM não entra na conta: a venda somente chip é sempre de chip
 * físico.
 */
export function isChipOnlyPickUpVisible({
  physicalChipAvailable,
  pickUpInStore,
}: ChipOnlyPickUpVisibilityInput): boolean {
  return physicalChipAvailable && pickUpInStore === true
}

export interface StorePickupSelectedInput {
  pickUpChip: boolean
  pickUpInStore?: boolean
}

/**
 * Se a retirada na loja vale para o frete e para o `retirada_mvno` do pedido.
 *
 * `pickUpChip` sozinho não basta: ele pode vir do checkout persistido ou de
 * uma escolha anterior, e a API zera o frete com base nesse campo sem
 * conferir a marca.
 */
export function isStorePickupSelected({
  pickUpChip,
  pickUpInStore,
}: StorePickupSelectedInput): boolean {
  return pickUpChip && pickUpInStore === true
}
